import AgoraRTC, { 
    CameraVideoTrackInitConfig, 
    ICameraVideoTrack, 
    IMicrophoneAudioTrack, 
    MicrophoneAudioTrackInitConfig 
} from "agora-rtc-sdk-ng"
import AgoraManager, { IAgoraManagerProps } from "./AgoraManager"

interface IInitializeProps {
    audioConfig?: MicrophoneAudioTrackInitConfig | undefined,
    videoConfig?: CameraVideoTrackInitConfig | undefined,
    audioOnly?: boolean
}

/**
 * This class will handle the microphone and camera tracks. It will be used as
 * the main videocall class to instantiate an object that will be used
 * by agora as the main input sources
 */
class AgoraRegularManager extends AgoraManager 
{
    /**
     * Audio and video tracks
     */
    tracks: [IMicrophoneAudioTrack, ICameraVideoTrack | undefined] | undefined
    audioOnly: boolean

    constructor(props: IAgoraManagerProps)
    {
        super(props)
        this.audioOnly = props?.audioOnly || false
    }

    async initialize(props?: IInitializeProps)
    {
        if(!this.client)
            super.initializeClient()

        try
        {
            this.tracks = await AgoraRTC.createMicrophoneAndCameraTracks(props?.audioConfig, props?.videoConfig)
        }
        catch(error)
        {
            console.warn("AgoraRegularManager Create Microphone")
            const track = await AgoraRTC.createMicrophoneAudioTrack()
            this.tracks = [track, undefined]
            this.audioOnly = true
        }
    }

    /**
     * Leaves the client and destroys the tracks
     */
    async destroy()
    {
        try
        {
            await this.client?.leave()
        }
        catch(error)
        {
            console.warn("Destroy regular manager", error)
        }

        if(this.tracks)
        {
            this.tracks.forEach(track => {
                if(track)
                    AgoraManager.destroyTrack(track)
            })
            this.tracks = undefined
        }

        this.client = undefined
    }
}

export default AgoraRegularManager
